"use strict";

import {
  BANNER_CONFIRM_BUTTON,
  BANNER_HEADER,
  BANNER_SETTINGS_BUTTON,
  BANNER_DESCRIPTION,
  DIALOG_PREFERENCES,
  UNABLE_TO_INSERT_HTML,
  DIALOG_SAVE_BUTTON,
  BANNER_PURPOSES,
  BANNER_PREFERENCES,
} from "@/helpers/constants";

import { getElement } from "@/services/dom";
import { allowOneDetailsOpen, combineCheckboxes, formatExpiry } from "@/helpers";

import html from "@/view/view.html?raw";

import type { CookiePurpose, Content, Cookiedock } from "@/view/types";

export function injectCookiedockDOM({ content, cookie_purposes }: Cookiedock) {
  try {
    const element: HTMLDivElement = document.createElement("div");
    element.innerHTML = html;
    document.body.insertAdjacentHTML("beforeend", element.innerHTML);
    innerHTML(content, cookie_purposes);
  } catch (error) {
    console.error(error, UNABLE_TO_INSERT_HTML);
  } finally {
    const dialog = getElement<HTMLDialogElement>("#__dialog", document, false);
    dialog.addEventListener("click", (event) => (event.target === dialog ? dialog.close() : null));
  }
}

// TODO:: add cookie purposes to the dom
function innerHTML({ banner_headline, banner_text, button_ok, button_show_details, button_hide_details, mandatory_text }: Content, purposes: CookiePurpose[]) {
  getElement<HTMLDivElement>(`.${BANNER_HEADER}`, document, true).forEach((element) => (element.innerHTML = banner_headline));
  getElement<HTMLDivElement>(`.${BANNER_DESCRIPTION}`, document, true).forEach((element) => (element.innerHTML = banner_text));
  getElement<HTMLButtonElement>(`.${BANNER_CONFIRM_BUTTON}`, document, false).innerHTML = button_ok;
  getElement<HTMLButtonElement>(`.${BANNER_SETTINGS_BUTTON}`, document, true).forEach((element) => (element.innerHTML = button_show_details));
  getElement<HTMLButtonElement>(`.${DIALOG_SAVE_BUTTON}`, document, false).innerHTML = button_hide_details;

  cookiePreferences(purposes);
  cookieDialogPreferences(purposes, mandatory_text);
  cookiePurposes(purposes);

  combineCheckboxes();
}

function cookiePreferences(purposes: CookiePurpose[]) {
  getElement<HTMLDivElement>(".checkbox", document, true).forEach((element) => {
    const content = purposes
      .flatMap(
        ({ category, mandatory }) => `
          <label class="-radio-label" for="${category}" ${mandatory ? "disabled" : ""}>
            ${category}
            <input type="checkbox" class="${BANNER_PREFERENCES}" id="${category}" name="${category}" data-group="${category}" ${mandatory ? "checked disabled" : ""} />
          </label>
        `,
      )
      .join("")
      .replace(/\n/g, "");

    element.innerHTML += content;
  });
}

function cookieDialogPreferences(purposes: CookiePurpose[], mandatory_text: string) {
  getElement<HTMLDivElement>(".body", document, true).forEach((element) => {
    const content = purposes
      .flatMap(
        ({ category, mandatory }) =>
          `<details class="__details">
                <summary class="--group">
                    <div class="__col">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 12H17" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 17V7" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>  
                        <p class="-label">${category}</p>                      
                    </div>
                    
                    ${
                      mandatory
                        ? `<details class="${DIALOG_PREFERENCES}" data-group="${category}">
                            <summary class="-active">${mandatory_text}</summary>
                          </details>`
                        : `<details class="${DIALOG_PREFERENCES}" data-group="${category}">
                            <summary></summary>
                          </details>`
                    }
                </summary>
                  <div class="__purposes-container">
                      <div class="__header">
                        <div class="__col">Name</div>
                        <div class="__col">Automaticly</div>
                        <div class="__col">Expires in</div>
                      </div>
                      <hr />
                      <div class="__row">
                        <div class="_col ${BANNER_PURPOSES} ${category}"></div>
                      </div>
                  </div>
            </details>`,
      )
      .join("")
      .replace(/\n/g, "");

    element.innerHTML += content;
  });

  allowOneDetailsOpen(".__details");
}

function cookiePurposes(purposes: CookiePurpose[]) {
  purposes.forEach(({ category, detected_cookies }) => {
    const element = getElement<HTMLDivElement>(`.${BANNER_PURPOSES}.${category}`, document, false);

    if (element.classList.contains("empty")) return;

    if (detected_cookies.length > 0) {
      const content = detected_cookies
        .map(
          ({ cookie_name, automatic_detected, expiry, cookie }) =>
            `<details class="-details">
                <summary class="-summary">
                    <div class="__row"> 
                        <div class="__col">${cookie_name} </div>
                        <div class="__col">${automatic_detected} </div>
                        <div class="__col">${formatExpiry(expiry)}</div>
                    </div>
                </summary>
                <div class="-summary-content">${cookie?.description ?? ""}</div>
            </details>`,
        )
        .join("")
        .replace(/\n/g, "");

      element.innerHTML += content;
    }
  });

  allowOneDetailsOpen(`.-details`);
}
